import { Module, GetterTree, MutationTree, ActionTree } from 'vuex';
import { Process, SimpleProcess, Step } from '@attensi/api-js';

import { ProcessModuleState, RootState } from '../types/ModuleTypes';
import { Filter, ProcessStats } from '../types/ProcessTypes';

import { ProcessAnalyser } from '../service/processAnalyser';

const state: ProcessModuleState = {
    active: {
        process: null,
        processId: null,
        step: null,
    },
    review: {
        process: null,
        stats: null,
    },
    processes: [],
    categories: [],

    filter: null,
    isListProcessing: false,
    isViewProcessing: false,
};

const getters: GetterTree<ProcessModuleState, RootState> = {
    activeProcess: (state) => state.active.process,
    activeProcessId: (state) => state.active.processId,
    activeStep: (state) => state.active.step,
    reviewProcess: (state) => state.review.process,
    reviewStats: (state) => state.review.stats,
    processes: (state) => state.processes,
    categories: (state) => state.categories,
    filter: (state) => state.filter,
    isListProcessing: (state) => state.isListProcessing,
    isViewProcessing: (state) => state.isViewProcessing,
};

const actions: ActionTree<ProcessModuleState, RootState> = {
    setActiveProcess({ commit }, process: Process) {
        commit('setActiveProcess', process);
    },
    setProcesses({ commit }, processes: SimpleProcess[]) {
        commit('setProcesses', processes);
    },
    setActiveStep({ commit }, step: Step) {
        commit('setActiveStep', step);
    },
    setNextStep({ dispatch }) {
        if (!state.active.step) { return; }
        const nextStepIndex = state.active.step.index + 1;
        dispatch('_setActiveStepByIndex', nextStepIndex);
    },
    setPreviousStep({ dispatch }) {
        if (!state.active.step) { return; }
        const nextStepIndex = state.active.step.index - 1;

        dispatch('_setActiveStepByIndex', nextStepIndex);
    },
    setFirstStep({
        dispatch,
    }) {
        dispatch('_setActiveStepByIndex', 0);
    },

    _setActiveStepByIndex({ commit }, stepIndex) {
        if (!state.active.process) { return; }
        const step = state.active.process.steps.find((step) => step.index === stepIndex);
        if (step) {
            commit('setActiveStep', step);
        }
    },
    setNewFilter({ commit }, filter: Filter) {
        commit('setNewFilter', filter);
    },
    setReviewProcess({ commit }, reviewProcess: Process) {
        let stats: ProcessStats | null = null;
        if (reviewProcess) {
            const processAnalyser = new ProcessAnalyser();
            stats = processAnalyser.getStats(reviewProcess);
        }

        commit('setReviewStats', stats);
        commit('setReviewProcess', reviewProcess);
    },
};

const mutations: MutationTree<ProcessModuleState> = {
    setActiveProcess(state, process: Process) {
        state.active.process = process;
        if (process) {
            state.active.processId = process.id;
        } else {
            state.active.processId = null;
        }
    },
    setProcesses(state, processes: SimpleProcess[]) {
        state.processes = processes;
    },
    setActiveStep(state, step: Step) {
        state.active.step = step;
    },
    setNewFilter(state, filter: Filter) {
        state.filter = filter;
    },
    setIsListProcessing(state, isListProcessing: boolean) {
        state.isListProcessing = isListProcessing;
    },
    setIsViewProcessing(state, isViewProcessing: boolean) {
        state.isViewProcessing = isViewProcessing;
    },
    setReviewStats(state, reviewStats: ProcessStats) {
        state.review.stats = reviewStats;
    },
    setReviewProcess(state, reviewProcess: Process) {
        state.review.process = reviewProcess;
    },
};


const namespaced: boolean = true;

export const processModule: Module<ProcessModuleState, RootState> = {
    namespaced,
    state,
    getters,
    actions,
    mutations,
};
